import { orgRepository } from "@/features/storage/repositories/org.repository";
import { physicalRepository } from "@/features/storage/repositories/physical.repository";

class SeatConfigurationService {
    private physicalRepository = physicalRepository;
    private orgRepository = orgRepository;

    private subscriptions: Array<(changes: unknown) => void> = [];

    /**
     * Subscribe to all changes in the storage service, so React components be notified to re-render.
     */
    subscribe(callback: (changes: unknown) => void): () => void {
        this.subscriptions.push(callback);

        return () => {
            this.subscriptions = this.subscriptions.filter((cb) => cb !== callback);
        };
    }

    notifySubscribers(changes: unknown) {
        this.subscriptions.forEach((callback) => callback(changes));
    }

    addSeatToRoom(roomId: string, location: { x: number; y: number }): void {
        this.physicalRepository.addSeatToRoom(roomId, location);

        this.notifySubscribers({ type: "seat-added", roomId });
    }

    removeSeatFromRoom(roomId: string, seatId: string): void {
        this.physicalRepository.removeSeatFromRoom(roomId, seatId);

        this.notifySubscribers({ type: "seat-removed", roomId, seatId });
    }

    updateSeatLocation(roomId: string, seatId: string, newLocation: { x: number; y: number }): void {
        this.physicalRepository.updateSeatLocation(roomId, seatId, newLocation);

        this.notifySubscribers({ type: "seat-moved", roomId, seatId, newLocation });
    }

    addEmployeeToSeat(seatId: string, employeeId: string): void {
        const employee = this.orgRepository.findEmployeeById(employeeId);
        if (!employee) {
            console.error(`Employee with ID ${employeeId} not found.`);
            return;
        }

        this.physicalRepository.assignEmployeeToSeat(seatId, employee);

        this.notifySubscribers({ type: "employee-assigned", seatId, employeeId });
    }

    removeEmployeeFromSeat(seatId: string): void {
        this.physicalRepository.removeEmployeeFromSeat(seatId);

        this.notifySubscribers({ type: "employee-removed", seatId });
    }
}

export const seatConfigurationService = new SeatConfigurationService();
